export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/internet_technology.dc513d0.svg";